/*                                                                            */
/*                                                                    */
/*                                                                         */
/*                                                                      */

interface HcSheetState {
  open: boolean;
  /*                                                     */
  title: string;
  /*                                                                    */
  secondLevel: boolean;
  /*                                                                         */
  secondLevelNbf: boolean;
  /*                                                                                      */
  secondLevelHeadline: string;
  /*                                                                                */
  navigation: boolean;
}

type Handler = () => void;

export const hcSheetState = $state<HcSheetState>({
  open: false,
  title: "",
  secondLevel: false,
  secondLevelNbf: false,
  secondLevelHeadline: "",
  navigation: false,
});

/*                                                                          */
/*                                                                           */
const handlers: { close?: Handler; back?: Handler } = {};

export function onHcSheetClose(handler: Handler): void {
  handlers.close = handler;
}

export function onHcSheetBack(handler: Handler): void {
  handlers.back = handler;
}

export function openHcSheet(title = ""): void {
  hcSheetState.title = title;
  hcSheetState.open = true;
}

/*                                                              */
export function markHcSheetClosed(): void {
  hcSheetState.open = false;
}

export function setHcSheetSecondLevel(active: boolean, headline = "", nbf = false): void {
  hcSheetState.secondLevel = active;
  hcSheetState.secondLevelNbf = active && nbf;
  hcSheetState.secondLevelHeadline = active ? headline : "";
  hcSheetState.navigation = false;
}

/**
 *
 *
 *
 */
export function setHcSheetNavigation(active: boolean, headline = ""): void {
  hcSheetState.secondLevel = active;
  hcSheetState.secondLevelNbf = false;
  hcSheetState.secondLevelHeadline = active ? headline : "";
  hcSheetState.navigation = active;
}

/*                                                                                   */
export function requestHcSheetClose(): void {
  if (handlers.close) {
    handlers.close();
  } else {
    markHcSheetClosed();
  }
}

/*                                                                                       */
export function requestHcSheetBack(): void {
  handlers.back?.();
}
